import React from "react";
import ActionGroup from "../components/ActionGroup";
import SiteLayout from "../components/SiteLayout";
import { aboutHighlights, lizzieStory, utilityActions } from "../siteContent";

const About = () => {
  return (
    <SiteLayout>
      <section className="page-hero page-hero--about-lizzie">
        <div className="container page-hero__grid about-lizzie-hero">
          <div className="about-lizzie-hero__copy">
            <h1>About Lizzie</h1>
            <p className="lead">
              Lizzie specialises in grey blending and colour analysis because
              both services have the power to change how a woman sees herself,
              not just how she wears her hair.
            </p>
            <ActionGroup
              actions={utilityActions}
              className="about-lizzie-hero__actions"
            />
          </div>

          <figure className="about-lizzie-hero__image">
            <img alt="Lizzie Fox portrait" src="/images/lizzie-about.webp" />
          </figure>
        </div>
      </section>

      <section className="section">
        <div className="container split-layout">
          <div style={{ marginTop: "10%" }}>
            <p className="section-eyebrow">Why This Work Matters</p>
            <h3 style={{ marginBottom: "2rem" }}>Confidence comes through colour</h3>
            <div className="pill-row">
              {aboutHighlights.map((item) => (
                <span className="pill" key={item}>
                  {item}
                </span>
              ))}
            </div>

            <div className="story-copy">
              {lizzieStory.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </div>
          <div>
            <figure
              className="about-lizzie-hero__image"
              style={{ paddingTop: "0", marginTop: "-75px" }}
            >
              <img
                alt="Lizzie Fox portrait"
                src="/images/lizzie-about-lower.webp"
              />
            </figure>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default About;
